<template>
  <span :class="[`thema-${thema}`, 'cursor']"
    :style="{ fontSize: `${btnSize}px`, lineHeight: `${btnSize}px`, ...customDesign }"
    @click.prevent.stop="handleClick && !readOnly ? handleClick() : ''">
    {{ btnText }}
  </span>

</template>

<script setup>

import { onMounted, defineProps, defineEmits } from 'vue';
const props = defineProps({
  thema: {
    type: String,
    default: 'default'
  },
  btnText: {
    type: String,
    default: ''
  },
  btnSize: {
    type: Number,
    default: 15
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  customDesign: {
    type: Object,
    default: () => ({})
  }

  //customDesign 옵션
  // width: '100%',
  // height: '50px',
  // padding: '10px',
  // color: '#f0f0f0'
  // backgroundColor: '#f0f0f0'
  // textAlign: 'center'

  //  사용
  // <c-btn :thema="'dark-gray'" :btnText="'일정가져오기'" :readOnly="false" :btnSize="13" :customDesign="{ color: 'red' }" @onClicked="dateSelect"></c-btn>

});
onMounted(() => {

})
const emit = defineEmits([
  'onClicked'
])

const handleClick = () => {
  emit('onClicked')
}

</script>
<style lang="scss" scoped>
@import '@/sass/app.scss';

.cursor {
  cursor: pointer;
}

.thema-gray {
  border-radius: 12px;
  background-color: #f7f7f7;
  display: inline-block;
  padding: 15px 24px;
  color: #666;
  font-family: 'Pretendard GOV';
  text-align: center;
}

.thema-dark-yellow {
  border-radius: 12px;
  background-color: #b49852;
  display: inline-block;
  padding: 15px 24px;
  color: #fff;
  font-family: 'Pretendard GOV';
  text-align: center;
}

.thema-fw-gby {
  display: inline-block;
  letter-spacing: -0.4px;
  line-height: 13px;
  font-weight: 500;
  border-radius: 12px;
  background-color: #CAAD57;
  padding: 15px 16px;
  font-size: 14px;
  color: #fff;
  font-family: 'Pretendard';
  text-align: center;
}

.thema-fgr-gw-bdgr {
  display: inline-block;
  letter-spacing: -0.4px;
  line-height: 13px;
  font-weight: 500;
  border-radius: 12px;
  border: none;
  background-color: #f7f7f7;
  padding: 15px 16px;
  font-size: 14px;
  color: #666;
  font-family: 'Pretendard GOV';
  text-align: center;
}

</style>
